/**
 * A data service that interfaces with the time slot resource.
 */
export class ScheduleEventTimeSlotService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http;
        this.apexApiUrl = apexApiUrl;
    }
    retrieveScheduleEventTimeSlots(scheduleEventID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/schedule-events/${scheduleEventID}/time-slots`,
            params: query
        }).then(response => response.data);
    }

    retrieveOfficeScheduleEventTimeSlots(icdOfficeID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/icd-offices/${icdOfficeID}/schedule-event-time-slots`,
            params: query
        }).then(response => response.data);
    }

    retrieveCorporationScheduleEventTimeSlots(icdCorporationID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/icd-corporations/${icdCorporationID}/schedule-event-time-slots`,
            params: query
        }).then(response => response.data);
    }

    retrieveEmployeeScheduleEventTimeSlots(employeeID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/employees/${employeeID}/assigned-schedule-events`,
            params: query
        }).then(response => response.data);
    }
}
